export {
  default as ConfigurationProvider
} from '@components/provider/configuration/ConfigurationProvider';



// WEBPACK FOOTER //
// ./src/components/provider/configuration/index.ts